try {
            if (process.env.TOKENS_FEATURE_FLAG === 'true') require('./index-new.css');
            else require('./index.css');
          } catch (e) {
            if (e.code !== 'MODULE_NOT_FOUND') {
              throw e; // Re-throw unexpected errors
            }
            console.warn('index.css not found, proceeding without it.');
          }
          

import { jsxs, jsx } from 'react/jsx-runtime';
import { Link } from '@design-system/link';
import { Typography } from '@design-system/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';

const RetailersBlock = forwardRef(({ className, retailerLinks, type, label, titleOptions = { variant: 'body', tag: 'p', size: 's' }, onClickRetailerName, }, ref) => (jsxs("div", Object.assign({ ref: ref, className: classNames('cds-retailers', className, {
        [`cds-retailers--${type}`]: type,
    }) }, { children: [label && (jsx(Typography, Object.assign({ id: "retailers", className: "cds-retailers__title" }, Object.assign(Object.assign({}, titleOptions), { content: label })))), jsx("ul", Object.assign({ "aria-labelledby": "retailers", className: "cds-retailers__items" }, { children: retailerLinks.map(({ link: { component: LinkElement = Link, props }, titleAsText, children, }, index) => (jsx("li", Object.assign({ className: "cds-retailers__item" }, { children: jsxs(LinkElement, Object.assign({ onClick: onClickRetailerName
                        ? () => onClickRetailerName((props === null || props === void 0 ? void 0 : props.title) || '', props.href)
                        : undefined, className: classNames(titleAsText && 'cds-link-with-text') }, props, { children: [children, titleAsText && (jsx("span", Object.assign({ className: "cds-retailers__item__text" }, { children: props.title })))] })) }), props.href + index))) }))] }))));

export { RetailersBlock };
